import React from 'react';
import './FaultFirstPage_Bus/FaultFirstPageCustom_bus.css'
import DashboardMain_Bus from '../DashboardMain_Bus/DashboardMain_Bus';
import FaultFirstPageCharts_Bus from './FaultFirstPage_Bus/FaultFirstPageCharts_Bus';
import FaultFirstPageDataBars_Bus from './FaultFirstPage_Bus/FaultFirstPageDataBars_Bus';
import FaultFirstPageFilters_Bus from './FaultFirstPage_Bus/FaultFirstPageFilters_Bus';
import FaultFirstPageKpis_Bus from './FaultFirstPage_Bus/FaultFirstPageKpis_Bus';
import FaultFirstPageBarChart_Bus from './FaultFirstPage_Bus/FaultFirstPageBarChart_Bus';
import { useCallback, useContext, useEffect, useState } from "react";
import moment from 'moment';
import { INIT_FILTER_STATE } from '../../../constants/driveglobalfilterinitalstates_bus';
import { API_URL_MAIN } from '../../../constants/driveglobalfilterinitalstates_bus';
import useHttp from '../../../hook/use-http'
import AppContext from '../../../store/AppContext';
import Faultanalysis_Bus from './Faultanalysis_Bus';
import { decodeToken } from 'react-jwt';

export default function FaultPage() {
  const tokenNew = JSON.parse(sessionStorage.user);
  let decodedToken = decodeToken(tokenNew.token);
  const city_name = decodedToken.city_name;
  const city_name_arr = city_name.split(",");
  const depo_name = decodedToken.depo_name;
  const depo_name_arr = depo_name.split(",");
  let sampleObj = (city_name != "") ? { ...INIT_FILTER_STATE, CITY: city_name_arr, DEPO: depo_name_arr } : INIT_FILTER_STATE

  const [gloablfilter, setGloablfilter] = useState(sampleObj)
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const app_ctx = useContext(AppContext);
  const log_data = (data) => {
  }

  useEffect(() => {
    fetchData({
      url: API_URL_MAIN + "auth/logging", body: {
        page_name: "faultanalysis_bus"

      }
    }, log_data)
  }, []);
  const filterSubmited = useCallback((data) => {
    setGloablfilter(data);
  }, []);

  const singleVinSelected = (vin) => {
    let vin_num = vin.split(",");
    setGloablfilter((prevdata) => { return { ...prevdata, VIN_NUM: vin_num, pageSelected: 2 } });
  }

  const pageChange = () => {
    setGloablfilter((prevdata) => {
      return { ...prevdata, pageSelected: 1, VIN_NUM: [] }
    });
  }

  const onreset = (data) => {
    setGloablfilter(data);
  }

  if (gloablfilter.pageSelected === 1) {
    return (
      <>
        <DashboardMain_Bus>
          <FaultFirstPageFilters_Bus onsubmit={filterSubmited} gloablfilter={gloablfilter} onreset={onreset} />
          <div className="container-fluid busdrpg1">
            <FaultFirstPageKpis_Bus gloablfilter={gloablfilter} />
            <section className="graphs sec2Charts">
              <FaultFirstPageDataBars_Bus singleVinSelected={singleVinSelected} gloablfilter={gloablfilter} />
              <div className="row mt-4 equal-cols">
                <FaultFirstPageCharts_Bus gloablfilter={gloablfilter} />
                <FaultFirstPageBarChart_Bus gloablfilter={gloablfilter} />
              </div>
            </section>
          </div>
        </DashboardMain_Bus>
      </>
    );
  } else {
    return (
      <Faultanalysis_Bus gloablfilter={gloablfilter} pageChange={pageChange} />
    );
  }
}